import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateState } from '../../../../commons/redux/actions/service.action'
import { serviceReducer } from '../../../../commons/redux/reducer/service.reducer'
import { returnSub } from '../../../../commons/utils'
import TagCustom from '../../../admin/components/ServicesDemand/tag'

export default function ItemService({
  desc,
  price,
  town,
  district,
  date,
  time,
  kind,
  _id,
  make,
  code,
}) {
  const [ID, setID] = useState()
  const [data, setData] = useState()
  const [select, setSelect] = useState('')
  const [selected, setSelected] = useState('selected')

  const dispatch = useDispatch()

  const { service } = useSelector((state) => state.serviceReducer)
  const onChangeState = (value, _id) => {
    const disp = dispatch(updateState(value, _id))
  }
  return (
    <div>
      <div className="bg-white border p-2 mx-auto  my-3 flex-col">
        <p className="h-2 w-2 bg-red-500 rounded-full"></p>
        <h1 className="titreItem">Service details</h1>
        <div className="flex">
          {' '}
          <p className="text text-sm font-bold">{desc} </p>
        </div>
        <div className="flex p-2 flex-wrap justify-content-center text-center align-items-center align-content-center">
          <div>
            <p className="text-xs text-muted">Budget</p>

            <TagCustom size={'md'} price={price + ''} colorScheme="red" />
          </div>
          <div>
            <p className="text-xs text-muted">Adresse</p>
            <TagCustom size={'md'} price={town} colorScheme="cyan" />
            <TagCustom size={'md'} price={district + ''} colorScheme="blue" />
          </div>
          <div>
            <p className="text-xs text-muted">Moment</p>
            <TagCustom size={'md'} price={date} colorScheme="red" />
            <TagCustom size={'md'} price={time} colorScheme="blue" />
          </div>
          <div>
            <p className="text-xs text-muted">Type</p>
            <TagCustom size={'md'} price={kind[0]} colorScheme="red" />
          </div>
        </div>
        <hr />
        <div className="flex justify-between flex-wrap">
          <div className="flex text-xs justify-content-right align-items-center">
            <h3 className="text-black font-bold">CodeID :</h3>
            <p>{code ? code : '000h'}</p>
          </div>
          <div>
            <form action="" method="post">
              <div class="form-check form-switch text-sm">
                <select
                  name="state"
                  onClick={onChangeState}
                  className="form-select shadow-none text-xs mt-1"
                  id="state"
                >
                  {service?.make ? (
                    <option value="Effectue" selected>
                      Effectue
                    </option>
                  ) : (
                    <option value="Effectue">Effectue</option>
                  )}
                  <option
                    value="Non effectue"
                    {...(service?.make ? selected : select)}
                  >
                    Non effectue
                  </option>
                </select>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}
